import { Button } from "@/components/clickable";
import { VStack } from "@/components/layout";
import AuthorizeGate from "@/modules/authorize/gate";

export default function Empty() {
  return (
    <>
      <VStack className="gap-3">
        <h2 className="text-2xl font-medium">Welcome to CounselPro</h2>
        <div className="max-w-xl">
          <p className="text-base text-zinc-600">
            Get started by creating a new project that will contain your
            client’s bank statements and credit card statements
          </p>
        </div>
      </VStack>
      <VStack className="h-[70%] w-full items-center justify-center gap-3.5">
        <p className="text-sm font-normal text-zinc-600">
          You have no active projects
        </p>
        <AuthorizeGate>
          <Button href="/new">Create new project</Button>
        </AuthorizeGate>
      </VStack>
    </>
  );
}
